export const introTitle = {
  title:
    '<span>Good Sensible</span><span>Front-End</span><span>Developer</span>',
  name: 'HwaYeon Song',
};

export const introduction =
  '안녕하세요! 프론트엔드 개발자 <span>송화연</span>입니다.<br />' +
  '토익 공부가 너무 지겨워 영어를 쉽게 잘할 수 있는 웹어플리케이션을 만들겠다는 결심 하나로 IT에 입문하게 되었습니다.<br />' +
  '학습력과 이해력이 누구보다 좋아 IT 입문 6개월 만에 마음이 맞는 3명의 팀원들과 <span>스타트업</span>을 창업하여 3년간 운영 및 프론트엔드 개발을 하였습니다.<br/>' +
  '평일에는 VanillaJS 또는 React.JS로 다양한 SPA 프로젝트를 만들고 있으며, ' +
  '<a href="https://github.com/eee0930/CodeCrushers" target="_blank" rel="noreferrer">게으른 개발너드</a>의 스터디장으로서 ' +
  '각자 다른 언어를 사용하고 있는 개발자들과 매주 토요일마다 모여 모각코 및 스터디를 진행하고 있습니다.<br/><br/>' +
  '동료들의 의견을 귀담아 듣고, 피드백 또한 잘 받아들입니다.<br/>건강하고 밝은 INTP이며, 편견이 없고 누구와도 잘 지내는 성격입니다 😙';

export const gitUrl = 'https://github.com/eee0930';
export const email = 'lazyhysong@gmail.com';

export const backColors = [
  'rgb(255,209,106)',
  'rgb(223,70,58)',
  'rgb(63,121,178)',
  'rgb(49,114,92)',
  'rgb(70,84,143)',
  'rgb(52,116,55)',
];

export const titles = {
  p: 'Period',
  c: 'Contribution',
  s: 'Skills',
  functions: '개발한 프로덕트의 기능 및 특징',
  issues: '개발 과정에서의 어려움 및 해결 방법',
  uses: '개발한 프로덕트의 활용 사례',
  etc: 'ETC',
};
